import React, { useState, useEffect } from "react"
import { Container } from "react-bootstrap"
import poweredByLogo from "../../assets/images/powered-by-profia.png"
import axios from "axios"

const Footer = () => {
  const currentYear = new Date().getFullYear()
  const [appVersion, setAppVersion] = useState(() => {
    // Show cached version immediately (if available)
    return localStorage.getItem("appVersion") || ""
  })

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        // Prefer build-injected version when available
        if (window.__UPDATE_VERSION__) {
          const updateVersion = window.__UPDATE_VERSION__
          setAppVersion(updateVersion)
          localStorage.setItem("appVersion", updateVersion)
          return
        }

        // Otherwise fetch latest deployed version
        const response = await axios.get("/version.json")
        if (response.data && response.data.version) {
          const latestVersion = response.data.version
          setAppVersion(latestVersion)
          localStorage.setItem("appVersion", latestVersion)
        }
      } catch (error) {
        console.error("Failed to fetch version information:", error)
      }
    }

    fetchVersion()
  }, [])

  const versionStyle = {
    color: "#ffffff80"
  }

  return (
    <footer>
      <Container fluid className="px-4">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <img src={poweredByLogo} alt="Powered by Profia" style={{ height: "20px" }} />
          </div>
          <div className="text-center" style={versionStyle}>
            {appVersion && <small>v{appVersion}</small>}
          </div>
          <div style={versionStyle}>
            <small>© {currentYear} e-Expert - All rights reserved.</small>
          </div>
        </div>
      </Container>
    </footer>
  )
}

export default Footer
